var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('yandex-map',{attrs:{"coords":_vm.coords,"zoom":_vm.zoom,"controls":_vm.controls}},[_c('ymap-marker',{attrs:{"coords":_vm.coords,"marker-id":"1","hint-content":"ЖК Mainstreet"},on:{"click":_vm.onMapClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }